// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legalCss_l7fssvh{color:var(--gray60a);font-size:12px;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-footer/dist/es/MinFooter/LegalText.css"],"names":[],"mappings":"AAAA,kBAAkB,oBAAoB,CAAC,cAAc,CAAC","sourcesContent":[".legalCss_l7fssvh{color:var(--gray60a);font-size:12px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
